<template>
  <div>
    <div class="row">
      <div class="md-auto col-md-8 text-right align-self-center">
        <span v-roles="['admin', 'owner']">Para solicitar documento presione la opción:</span>
      </div>
      <div class="col-md-1 text-left align-self-center">
        <el-button v-roles="['admin', 'owner']" class="btn btn-success" round @click="dialogDocumentOpenEvent = true">Solicitar</el-button>
      </div>
    </div>
    <div class="row">
      <p>Para ver los documentos adjuntos selecciona la opción <strong>Ver</strong> de cada fila</p>
    </div>
    <div class="row">
      <div class="col-md-12">
        <el-table
            v-loading="loading"
            ref="tblDocs"
            :data="tableDocuments"
            style="width: 100%"
            >
            <el-table-column
                label="Fecha"
                align="center"
                header-align="center"
                width="100"
                >
                <template slot-scope="scope">{{ scope.row['created_at'] }}</template>
            </el-table-column>
            <el-table-column
                label="Asunto"
                align="left"
                header-align="left"
                width="700"
                >
                <template slot-scope="scope">{{ scope.row['description'] }}</template>
            </el-table-column>
            <el-table-column
                v-roles="['user']"
                label="Detalle"
                align="right"
                header-align="right">
                  <template slot-scope="scope">
                      <el-button @click="openDialogDocumentToAttach(scope.row.id)">Ver</el-button>
                  </template>    
            </el-table-column>
        </el-table>
      </div>
    </div>

    <el-dialog 
      title="Solicitud de documento"
      width="50%"
      :visible.sync="dialogDocumentOpenEvent"
      center>
      <el-form ref="documentForm" :model="documentForm" v-loading="loading" :rules="rules">
        <el-form-item prop="description" label="Descripción" required>
          <el-input v-model="documentForm.description" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="Documentos (opcional)">
          
        </el-form-item>
      </el-form>
      <div class="text-center">
        <upload-form 
          :files="documentForm.documents" 
          type="invest" 
          @inputadd="(ids) => { filesnew = ids }" 
          @inputdel="(ids) => { filesdeleted = ids }"
          >
        </upload-form>
        <el-button @click="dialogDocumentOpenEvent = false">Cancelar</el-button>
        <el-button type="primary" @click="onFormSubmit('documentForm')">Aceptar</el-button>
      </div>
    </el-dialog>

    <el-dialog 
      title="Documentos adjuntos"
      width="80%"
      :visible.sync="dialogDocumentToAttachedEvent"
      center>
      <div class="text-center">
        <upload-form 
          v-roles="['user']"
          type="attach"
          @inputadd="attachFileEvent" 
          >
        </upload-form>
      </div>
      <br>
      <br>
      <br>
      <el-table
          v-loading="loading"
          ref="tblDocumentsAttach"
          :data="tableDocumentsAttach"
          style="width: 100%"
          >
          <el-table-column
            fixed
            width="100"
            label="Fecha"
            align="center"
            header-align="center"
            >
              <template slot-scope="scope">{{ scope.row.created_at }}</template>
          </el-table-column>
          <el-table-column
            fixed
            label="Nombre"
            align="left"
            width="400"
            header-align="left"
            >
              <template slot-scope="scope"><a :href="api_files + scope.row.key">{{ scope.row.name }}</a></template>
          </el-table-column>
          <el-table-column
              label="Estatus"
              align="center"
              width="100"
              header-align="left"
              >
              <template slot-scope="scope">
                <el-tag size="small" effect="dark" :type="getTypeAttach(scope.row)"><strong>{{getStatusAttach(scope.row)}}</strong></el-tag>
              </template>
          </el-table-column>
          <el-table-column
                label=""
                width="300"
                align="left">
                  <template slot-scope="scope">
                      <span v-if="scope.row.is_rejected">
                        Observaciones: {{scope.row.reasson_rejected}}
                      </span>
                      <br>
                      <span v-roles="['admin', 'owner']" v-if="scope.row.is_rejected">
                        Rechazado por: {{scope.row.rejected_by}}
                      </span>
                      <span v-roles="['admin', 'owner']" v-if="scope.row.is_authorized">
                        Autorizado por: {{scope.row.authorized_by}}
                      </span>
                  </template>
          </el-table-column>
          <el-table-column
                label=""
                width="300"
                align="right"
                header-align="right">
                  <template slot-scope="scope">
                      <el-row>
                        <el-button 
                          size="small"
                          icon="el-icon-circle-check"
                          type="success"
                          plain
                          v-roles="['admin', 'owner']"
                          @click="approveAttach(scope.row.id)">Aprobar</el-button>
                        <el-button 
                        size="small"
                        icon="el-icon-circle-close"
                        v-roles="['admin', 'owner']"
                        type="danger"
                        @click="rejectAttach(scope.row.id)">Rechazar</el-button>
                      </el-row>
                  </template>    
          </el-table-column>
      </el-table>
      <br>
      <br>
      <br>
      <div class="text-center">
        <el-button @click="dialogDocumentToAttachedEvent = false">Aceptar</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { Card, FormGroupInput, Alert } from '@/components';
import { Table, TableColumn, MessageBox, Message, Input, 
Button, Badge, Form, FormItem, Dialog, Tag, Row } from 'element-ui';
import Settings from '@/providers/Settings'
import Investments from '@/providers/Investments'

import UploadForm from '../../pages/components/UploadForm';

import _ from 'lodash'

const provider = new Settings()
const investProvider = new Investments()

export default {
  components: {
    Card,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput,
    Alert,
    [Input.name]: Input,
    [Badge.name]: Badge,
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    [Dialog.name]: Dialog,
    [Tag.name]: Tag,
    [Row.name]: Row,
    UploadForm
  },
  props: [
    'investId'
  ],
  directives: {
  },
  mounted() {
      this.getInvestDocumentsRequests(this.investId)
  },
  data() {
      return {
        documentForm: {
          description: "",
          documents: [],
          filesnew: [],
          invest_id: this.investId
        },
        documentAttachForm: {
          documents: [],
          filesnew: [],
          filesDeleted: [],
          invest_id: this.investId
        },
        rules: {
          description: [{ required: true, message: 'Campo requerido', trigger: 'blur' }]
        },
        loading: false,
        classValidation: '',
        tableDocuments: [],
        dialogDocumentOpenEvent: false,
        dialogDocumentToAttachedEvent: false,
        filesnew: [],
        filesdeleted: [],
        filesAttachNew: [],
        filesAttachDeleted:[],
        tableDocumentsAttach: [],
        api_files: this.$store.state.api_files
      }
  },
  methods: {
    onFormSubmit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let payload = _.cloneDeep(this.documentForm)
          payload.filesnew = this.filesnew
          console.info('save-> ', payload)
          investProvider.requestDocument(payload).then((response) => {
            this.dialogDocumentOpenEvent = false
            this.documentForm.description = "";
            this.getInvestDocumentsRequests(this.investId)
          }).catch((err) => {
            console.info('error get document request')
            console.info(err)
          })
        } else {
          return false;
        }
      })
    },
    getInvestDocumentsRequests(id) {
      investProvider.getRequestDocument(id).then((response) => {
        this.tableDocuments = response.data.data
      }).catch((err) => {
        console.info('error get invest docs request')
        console.info(err)
      })
    },
    getDocumentsAttached() {
      this.loading = true
      investProvider.getDocumentsAttached(this.requestIdSelected).then((response) => {
        this.tableDocumentsAttach = response.data.data
        this.loading = false
      }).catch((err) => {
        this.loading = false
        console.info('error get invest docs request')
        console.info(err)
      })
    },
    openDialogDocumentToAttach(requestId) {
      this.requestIdSelected = requestId
      this.dialogDocumentToAttachedEvent = true
      this.getDocumentsAttached()
    },
    attachFileEvent(document) {
      this.loading = true
      let data = {
        request_id: this.requestIdSelected,
        file_id: document.id
      }
      investProvider.attachDocument(data).then((response) => {
        this.getDocumentsAttached()
        this.loading = false
      }).catch((err) => {
        this.loading = false
        console.info('error attach request')
        console.info(err)
      }) 
    },
    approveAttach (attachId) {
      return MessageBox.confirm(`Al aprobar un documento se le notificará al inversor. ¿Continuar?`,
      "Confirmation",
      {
        confirmButtonText: "Si",
        cancelButtonText: "Cancelar",
        type: "warning"
      }).then(() => {
        this.loading = true
        let data = {
          status: 'approved'
        }
        investProvider.updateAttachStatus(attachId, data).then((response) => {
          MessageBox({
            type: 'success',
            message: 'El documento ha sido aprobado'
          });
          this.getDocumentsAttached()
          this.loading = false
        }).catch((err) => {
          this.loading = false
          console.info('error attach request')
          console.info(err)
        })
      }).catch(() => {
        return false
      })
       
    },
    rejectAttach (attachId) {
      return MessageBox.prompt(`Se requiere un motivo de rechazo. Se le notificará al inversor. ¿Continuar?`,
      "Confirmation",
      {
        confirmButtonText: "Si",
        cancelButtonText: "Cancelar",
        type: "warning"
      }).then((reasonReject) => {
        this.loading = true
        let data = {
          description: reasonReject.value,
          status: 'rejected'
        }
        investProvider.updateAttachStatus(attachId, data).then((response) => {
          MessageBox({
            type: 'success',
            message: 'El documento ha sido rechazado'
          });
          this.getDocumentsAttached()
          this.loading = false
        }).catch((err) => {
          this.loading = false
          console.info('error attach request')
          console.info(err)
        })
      }).catch(() => {
        return false
      })
    },
    getStatusAttach (row) {
      return row.is_authorized ? 'Autorizado' :  (row.is_rejected ? 'Rechazado' : 'En revisión')
    },
    getTypeAttach (row) {
        return row.is_authorized ? 'success' :  (row.is_rejected ? 'warning' : 'primary')
    },
    getFileLink(key) {

    }
  }
};
</script>
<style lang="scss" scoped>
</style>
